import getMessage from 'src/background/utils/i18n.utils';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { PendingSavingsWithdrawalItemComponent } from '@popup/steem/pages/app-container/home/savings/pending-savings-withdrawal/pending-savings-withdrawal-item/pending-savings-withdrawal-item.component';
import { Screen } from '@reference-data/screen.enum';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Separator } from 'src/common-ui/separator/separator.component';
const PendingSavingsWithdrawal = ({ savingsPendingWithdrawalList, currency, setTitleContainerProperties, }) => {
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_savings_current_withdrawing',
            isBackButtonEnabled: true,
        });
    });
    return (React.createElement("div", { className: "pending-savings-withdrawal-page", "data-testid": `${Screen.PENDING_SAVINGS_WITHDRAWAL_PAGE}-page` },
        React.createElement("div", { className: "list-panel" },
            React.createElement("div", { className: "pending-disclaimer" }, getMessage('popup_html_withdraw_savings_until_message', [
                currency,
            ])),
            React.createElement(Separator, { type: "horizontal" }),
            React.createElement("div", { className: "list" }, savingsPendingWithdrawalList.map((currentWithdrawItem) => {
                return (React.createElement(PendingSavingsWithdrawalItemComponent, { key: currentWithdrawItem.request_id, item: currentWithdrawItem, currency: currency }));
            })))));
};
const mapStateToProps = (state) => {
    return {
        savingsPendingWithdrawalList: state.navigation.stack[0].params
            .savingsPendingWithdrawalList,
        currency: state.navigation.stack[0].params.currency,
    };
};
const connector = connect(mapStateToProps, {
    setTitleContainerProperties,
});
export const PendingSavingsWithdrawalPageComponent = connector(PendingSavingsWithdrawal);
